
import { defineComponent } from 'vue';
import { IModelSelectionPool } from '../store/interfaces/IModelSelectionPool';
import { mdiCheckBold, mdiAlertCircle, mdiSwapHorizontal } from '@mdi/js';
import Icon from "./Icon.vue";

export default defineComponent({
    name: 'ModelSelector',
    data: () => ({
        visable: false,
        selectionPool: [] as IModelSelectionPool[],
        selectionPoolSearch: '',
        selectedPoolSearch: '',
        mdiSwapHorizontal,
        mdiCheckBold,
        mdiAlertCircle

    }),
    computed: {
        searchPlaceholder: function(): string {
            return 'Search ' + this.$props.modelTypeName;
        },

        isVisible: {
            

            get() {
                return this.modelValue != undefined ? this.modelValue : this.visable;
            },

            // setter
            set(newValue: boolean) {
                this.visable = newValue;
                this.$emit('update:modelValue', false);
            }

        },

        saveButtonText(): string {
            return this.addButton? 'Add' : 'Save';
        },

        shouldShowRemoveRoomMessage(): boolean {
            if(this.showRemoveRoomMessage && !this.selectionPool.filter((x: any)=>x.selected && !x.disabled).length) {
                return true;
            }
            return false;
        }
    },

    components: {
        Icon
    },

    props: {
        // For v-model
		modelValue: String,

        loading: Boolean,

        title: String,

        subTitle: String,

        modelTypeName: String,

        showRemoveRoomMessage: Boolean,

        showNoAccessRoomMessage: Boolean,

        addButton: Boolean,
        
        hideSaveButton: Boolean,

        includesAll: Boolean
    },
    
    emits: ['update:modelValue', 'selection-pool-change'],

    methods: {
        activate(selectionPoolInput: IModelSelectionPool[]) {
            if(selectionPoolInput.length > 0 && this.includesAll){
                const allOption: IModelSelectionPool = {
                    id: '*',
                    name: `All ${this.modelTypeName}`,
                    selected: false,
                    disabled: false
                };
                const clonedPool = Object.assign([], selectionPoolInput);
                this.selectionPool = [allOption, ...clonedPool];
          }
          else{
            this.selectionPool = Object.assign([], selectionPoolInput);
          }
            this.visable = true;
        },
        onCancel() {
            this.isVisible = false;
            this.selectionPool = [];
        },
        onSave() {
            if(!this.modelValue) {
                this.visable = false;
            }
            const filtered = this.selectionPool.filter(x => x.id !== '*');
            this.$emit('selection-pool-change', filtered);
        },
        selectionPoolClick(item: IModelSelectionPool) {
            if (item.disabled) return;

            if (this.includesAll && item.id === '*') {
                const nonAllItems = this.selectionPool.filter(x => x.id !== '*' && !x.disabled);
                const allCurrentlySelected = nonAllItems.length > 0 && nonAllItems.every(x => x.selected);
                
                const newSelectedState = !allCurrentlySelected;
                
                this.selectionPool.forEach(x => {
                    if (!x.disabled) {
                        x.selected = newSelectedState;
                    }
                });

                this.selectionPool = [...this.selectionPool];
                return;
            }

            if (this.includesAll && item.id !== '*') {
                item.selected = !item.selected;

                const nonAllItems = this.selectionPool.filter(x => x.id !== '*' && !x.disabled);
                const allSelected = nonAllItems.length > 0 && nonAllItems.every(x => x.selected);

                const allItem = this.selectionPool.find(x => x.id === '*');
                if (allItem) {
                    allItem.selected = allSelected;
                    this.selectionPool = [...this.selectionPool];
                return;
                }
            }

            item.selected = !item.selected;
            this.selectionPool = [...this.selectionPool];
        },
        selectedPoolClick(item: IModelSelectionPool) {
            if (!item.selected || item.disabled) return;
            
            const itemIndex = this.selectionPool.indexOf(item);
            this.selectionPool[itemIndex].selected = false;
            
            if (this.includesAll) {
                const nonAllItems = this.selectionPool.filter(x => x.id !== '*' && !x.disabled);
                const allSelected = nonAllItems.every(x => x.selected);
                
                const allItem = this.selectionPool.find(x => x.id === '*');
                if (allItem) {
                    allItem.selected = allSelected;
                }
            }
            
            this.selectionPool = [...this.selectionPool];
        }
    }
})
